import {
  ResponsesFundItemResponse,
  ResponsesPositionItemResponse,
} from '@genial/services/dist/models';
import { useBreakpointValue } from '@genial/utils';
import React, { useState } from 'react';

import { validateAndFormatValue } from '../../../../Table/constants';
import { messageError } from '../../constants';

import { PositionItemDesktop } from './desktop';
import { PositionItemTablet } from './tablet';

export interface PositionItemProps extends ResponsesFundItemResponse {}

export interface PositionItemResponsiveProps {
  isOpened: boolean;
  handleChangeIsOpened: () => void;
  totalQuota: string | number;
  fundPositions: ResponsesPositionItemResponse[];
  hasMultiplePositions: boolean;
  netValueTotal: string;
  totalApplication: string;
  iofValueTotal: string;
  totalGrossTotal: string;
  irValueTotal: string;
  fundName: string;
  applicationDate: string;
  profitabilityPosition: string;
  quotaValue: string;
}

export const PositionItem: React.FC<PositionItemProps> = ({
  fundName,
  fundPositions,
  totalQuotaQuantity,
  totalApplicationValue,
  totalGrossValue,
  totalIr,
  totalIof,
  totalNetValue,
}) => {
  const [isOpened, setIsOpened] = useState(false);
  const hasSinglePosition = fundPositions?.length === 1;
  const hasMultiplePositions = fundPositions && fundPositions?.length > 1;

  const fundInitialPosition = fundPositions
    ? fundPositions[0]
    : ({} as ResponsesPositionItemResponse);

  const applicationDate = validateAndFormatValue(
    hasSinglePosition ? fundInitialPosition?.applicationDate : null,
    'date'
  );
  const profitabilityPosition = validateAndFormatValue(
    hasSinglePosition ? fundInitialPosition?.profitability : null,
    'percentage'
  );
  const quotaValue = validateAndFormatValue(fundInitialPosition?.quotaValue, 'money');
  const totalQuota = totalQuotaQuantity || messageError;
  const totalApplication = validateAndFormatValue(totalApplicationValue, 'money');
  const totalGrossTotal = validateAndFormatValue(totalGrossValue, 'money');
  const irValueTotal = validateAndFormatValue(totalIr, 'money');
  const iofValueTotal = validateAndFormatValue(totalIof, 'money');
  const netValueTotal = validateAndFormatValue(totalNetValue, 'money');

  const handleChangeIsOpened = () => setIsOpened((state) => !state);

  const params = {
    handleChangeIsOpened,
    isOpened,
    fundName: fundName ?? messageError,
    applicationDate,
    profitabilityPosition,
    quotaValue,
    totalQuota,
    totalApplication,
    iofValueTotal,
    totalGrossTotal,
    irValueTotal,
    netValueTotal,
    hasMultiplePositions: !!hasMultiplePositions,
    fundPositions: fundPositions ?? [],
  };

  const positionResponsiveItem = useBreakpointValue({
    base: <PositionItemTablet {...params} />,
    lg: <PositionItemDesktop {...params} />,
  });

  return positionResponsiveItem;
};
